import { render, staticRenderFns } from "./IndiceSearchModal.vue?vue&type=template&id=bbdb30a0&"
import script from "./IndiceSearchModal.vue?vue&type=script&lang=js&"
export * from "./IndiceSearchModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports